export const SUGGEST_NEW_TUTOR_ONBOARDING_UNTIL_NUM_SESSIONS_HOSTED = 3
